<script>
import Loading from '../../components/loading.vue';
import StudyList from '../../components/studyList.vue';

export default {
    name: "studyDetail",
    data() {
        return {
            detail: {
                other_list: [],
            },
            isLoading: false,
        };
    },
    computed: {},
    components: {
        StudyList,
        Loading
    },
    mounted() {
    },
    destroyed() {},
    watch: {
        '$route': {
            handler: 'getDetail',
            immediate: true
        }
    },
    methods: {
        getDetail() { 
            this.isLoading = true;
            this.$store.dispatch('getStudyDetail', {
                id:this.$route.query.id
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.detail = result.data;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        }
    },
};
</script>

<template>
    <div class="studyDetail">
        <div class="loading_wrapper" v-if="isLoading"><Loading/></div>
        <div class="content" v-else v-html="detail.content"></div>
        <!--  -->
        <div class="list layout_main" v-if="detail.other_list.length > 0">
            <div class="title">相关课程与活动</div>
            <StudyList :data="detail.other_list" type="type2"/>
            <div class="flex justify_end">
                <router-link class="btn layout_flex_center" :to="`/study/list?id=${detail.category_id}`">更多相关课程活动</router-link>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
// .banner{
//     width: 100%;
//     height: 7.5rem;
// }
// .info{
//     padding: .5rem 0;
//     text-align: center;
//     font-size: .18rem;
//     color: #666;
//     line-height: 1.5;
//     .title,
//     .desc{
//         color: var(--font_color);
//         margin-bottom: .2rem;
//     }
//     .title{
//         font-size: .26rem;
//     }
//     .desc{
//         font-size: .22rem;
//     }
//     .link{
//         font-size: .2rem;
//         margin-bottom: .2rem;
//     }
// }
.loading_wrapper{
    padding: 3rem 0 1rem;
}
.list{
    padding: .5rem 0;
    .title{
        font-size: .25rem;
        text-align: center;
        margin-bottom: .3rem;
    }
    .btn{
        font-size: .16rem;
        color: #666;
        border: 1px solid #666;
        border-radius: .1rem;
        height: .28rem;
        padding: 0 .1rem;
        cursor: pointer;
        margin-top: .3rem;
    }
    @media only screen and (max-width: 750px) {
        .title{
            font-size: .32rem;
        }
        .btn{
            border: none;
            font-size: .22rem;
            margin: .5rem auto 0;
        }
    }
}
</style>